module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_phone.68677.png";